"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _reactBootstrap = require("react-bootstrap");
var _constants = require("../surveyCustom/preview/constants");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var isValidDate = function isValidDate(value) {
  if (_momentTimezone.default.isMoment(value)) {
    return value.isValid();
  }
  return value !== _constants.INVALID_DATE;
};

/**
 * The InputDateTime
 * Need to extend from PureComponent or Component.
 * Otherwise, DropDown cannot display properly
 * @extends PureComponent
 */
var InputDateTime = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(InputDateTime, _Component);
  var _super = _createSuper(InputDateTime);
  function InputDateTime(props) {
    var _this;
    (0, _classCallCheck2.default)(this, InputDateTime);
    _this = _super.call(this, props);
    var initValue = props.value || props.customValue;
    _this.state = {
      storeTime: isValidDate(initValue) ? initValue : ''
    };
    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.onKeyUp = _this.onKeyUp.bind((0, _assertThisInitialized2.default)(_this));
    _this.setValue = _this.setValue.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(InputDateTime, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        value = _this$props.value,
        customValue = _this$props.customValue;
      if (prevProps.value !== value || prevProps.customValue !== customValue) {
        this.setValue(value || customValue);
      }
    }
  }, {
    key: "onChange",
    value: function onChange(value) {
      this.setState({
        storeTime: value.target.value
      });
    }
  }, {
    key: "onKeyUp",
    value: function onKeyUp(e) {
      this.setState({
        storeTime: e.target.value
      });
    }
  }, {
    key: "setValue",
    value: function setValue(newValue) {
      this.setState({
        storeTime: newValue
      });
    }
  }, {
    key: "render",
    value: function render() {
      // Create ID
      var id = "".concat(this.props.name, "Input").concat(new Date().getTime());
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(this.props.disabled && 'input-group-disabled', " input-group")
      }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl, {
        type: "text",
        id: id,
        readOnly: this.props.readOnly,
        className: this.props.disabled ? this.props.dinputClass : 'input-date-time',
        onClick: this.props.onClick,
        onChange: this.onChange,
        onBlur: this.props.onBlur,
        onFocus: this.props.onFocus,
        onKeyUp: this.onKeyUp,
        value: this.state.storeTime || '',
        disabled: this.props.disabled,
        placeholder: this.props.placeholderText
      }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.ControlLabel, {
        disabled: this.props.disabled,
        htmlFor: id,
        bsClass: "input-group-addon btn"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: this.props.inputIconClass
      })));
    }
  }]);
  return InputDateTime;
}(_react.Component);
InputDateTime.propTypes = {
  onClick: _propTypes.default.func.isRequired,
  onFocus: _propTypes.default.func.isRequired,
  onBlur: _propTypes.default.func,
  value: _propTypes.default.string.isRequired,
  customValue: _propTypes.default.string,
  inputIconClass: _propTypes.default.string,
  name: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  dinputClass: _propTypes.default.string,
  placeholderText: _propTypes.default.string
};
InputDateTime.defaultProps = {
  inputIconClass: 'fa fa-calendar',
  name: 'dateTime',
  disabled: false,
  readOnly: true,
  dinputClass: null,
  onBlur: _lodash.default.noop,
  placeholderText: '',
  customValue: ''
};
var _default = InputDateTime;
exports.default = _default;